import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import ComponentSave from "./ComponentSave";
import GetComponent from "./ComponentGetComponentByID";
import UploadImage from "./ComponentEditUploadFile";


const ComponentNew = () => {

    let id = "";
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const [component, setComponent] = useState({});

    let response39 = useInvoke("WebApps", "39", null);
    let response40 = useInvoke("WebApps", "40", null);

    useEffect(() => {

        //Get all component categories
        if (response39.data.payload != undefined) {
            let data = JSON.parse(response39.data.payload).data;

            let select = document.getElementById("categoryID");

            let defaultOption = document.createElement('option');
            defaultOption.text = "Select Category";
            defaultOption.value = "";
            select.options.add(defaultOption);

            data.forEach(category => {
                let option = document.createElement('option');
                option.text = category[1];
                option.value = category[0];
                select.options.add(option);
            });
        }

        //get component types
        if (response40.data.payload != undefined) {
            let data = JSON.parse(response40.data.payload).data;

            let select = document.getElementById("typeID");

            let defaultOption = document.createElement('option');
            defaultOption.text = "Select Component Type";
            defaultOption.value = "";
            select.options.add(defaultOption);

            data.forEach(type => {
                let option = document.createElement('option');
                option.text = type[1];
                option.value = type[0];
                select.options.add(option);
            });
        }

    }, [response39.isPending, response40.isPending]);

    const handleFormSubmit = (e) => {

        let componentid = id;

        let valid = true;
    
        let componentcategoryid = "";
        if (document.getElementById("categoryID").value == "") {
            valid = false;
            toast.error("Component Category required");
        }
        else {
            componentcategoryid = document.getElementById("categoryID").value;
        }

        let componentname = "";
        if (document.getElementById("componentName").value == "") {
            valid = false;
            toast.error("Component Name required");
        }
        else {
            componentname = document.getElementById("componentName").value;
        }

        let componentdescription = "";
        if (document.getElementById("componentDescription").value == "") {
            valid = false;
            toast.error("Component Description required");
        }
        else {
            componentdescription = document.getElementById("componentDescription").value;
        }

        let componenttypeid = "";
        if (document.getElementById("typeID").value == "") {
            valid = false;
            toast.error("Component Type required");
        }
        else {
            componenttypeid = document.getElementById("typeID").value;
        }

        if (document.getElementById("imageupload").files[0] == undefined) {
            valid = false;
            toast.error("Image Required");
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if (valid) {
            ComponentSave (componentid, componentcategoryid, componentname, componentdescription, modifiedbyid, deleted, componenttypeid)
            .then((response) => {

                let newID = JSON.parse(response.payload).data[0][0];
                
                handleUpload(newID);
            });

            
        }
    };

    const handleUpload = (componentID) => {

        GetComponent(componentID)
        .then((response) => {
            handleComponentData(JSON.parse(response.payload).data[0]);
        });

        UploadImage (document.getElementById("imageupload").files[0], componentID, user["id"], )
        .then((response) => {

            if (response.status == 200) {
                toast.success("Success");

                // //re-render page
                // GetComponent(id)
                // .then((response) => {
                //     handleComponentData(JSON.parse(response.payload).data[0]);
                // });

                navigate(`/Component/Edit/${componentID}`);
            } 
            else {
                toast.error("Upload failed.");
            }
        });
    };

    const handleComponentData = (data) => {

        setComponent(
            {
                ComponentId: data[0],
                CategoryName: data[1],
                ComponentTypeName: data[2],
                ComponentName: data[3],
                ComponentDescription: data[4],
                CreatedDate: data[5],
                ComponentCategoryId: data[6],
                ComponentTypeId: data[7],
                ImageURL: ("https://dc.cssi.co/Images/" + data[8])
            }
        );
    };

    document.title = "Component - New";
    return ( 
        <div className="componentNew">

            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                        <h2>New Component</h2>

                        <form id="componentForm" method="post" noValidate="novalidate" autoComplete="off">    

                            <div className="form-group">
                                <label htmlFor="categoryID">Component Category</label>
                                <select className="form-control" id="categoryID" name="categoryID"></select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="componentName">Component Name</label>
                                <input className="form-control" id="componentName" name="componentName" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="componentDescription">Component Description</label>
                                <input className="form-control" id="componentDescription" name="componentDescription" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="typeID">Component Type</label>
                                <select className="form-control" id="typeID" name="typeID"></select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="imageupload">Image</label>
                                <input type="file" name="imageupload" id="imageupload" placeholder="Select a File" class="form-control" autocomplete="off" />
                            </div>
                        </form>
                        <Link to="/Component" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>                            
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>

                    <div className="modal" id="uploadModal" style={{display: "none"}} aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <form id="frmUpload" enctype="multipart/form-data" noValidate="novalidate" autoComplete="off">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Add Image For Component</h4>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            Select File to Upload
                                            <input type="file" name="file" id="file" required="required" placeholder="Select a File" className="form-control" autoComplete="off" />
                                        </div>
                                    </div>

                                    <input data-val="true" data-val-required="The Component field is required." id="ComponentId" name="ComponentId" type="hidden" value="00000000-0000-0000-0000-000000000000" autoComplete="off" />

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-default" data-bs-dismiss="modal">Close</button>
                                        <input type="submit" className="btn btn-success" value="Upload" id="btnImgSubmit" autoComplete="off" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </>
            }

            {/* This is needed for re-render trigger */}
            {component["ComponentId"] &&
                <div id={component["ComponentId"]} style={{visibility: "hidden"}}></div>
            }
            
        </div>
     );
}
 
export default ComponentNew;